import PropTypes from 'prop-types'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

import { Colors } from '~/styles'
import { Button } from '~/components'

import Styled from '../../generate-sr-modal.styled'

const ModalConfirm = (props) => {
  return (
    <Styled.StyledDialog
      id='mdl_vessel_forecast_generate_sr_dialog_confirmation'
      open={props.open}
      width={20}
      onClose={props.toggleModal}
      maxWidth='xs'
      aria-labelledby='mdl_vessel_forecast_generate_sr_dialog_confirmation'
      disableEnforceFocus={true}
      disableBackdropClick={true}
    >
      <Styled.Header id='mdl_comp_dialog_confirmation_header' whiteheader={props.whiteheader}>
        <Styled.TitleContainer>
          <Styled.DivTitle>
            <Styled.Title id='mdl_vessel_forecast_generate_sr_dialog_title'>Submit Request</Styled.Title>
          </Styled.DivTitle>
          <div id='modal-button' style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={props.toggleModal} aria-label='close' id='mdl_dialog_x_btn'>
              <CloseIcon htmlColor={Colors.pureWhite} />
            </IconButton>
          </div>
        </Styled.TitleContainer>
      </Styled.Header>
      <div id='mdl_comp_dialog_confirmation_content' style={{ padding: '24px' }}>
        <Styled.Subtitle id='mdl_vessel_forecast_generate_sr_dialog_subtitle'>Are you sure to submit this request? Make sure you have filled it correctly.</Styled.Subtitle>
        <Styled.ActionContainer>
          <Button
            id='vessel_forecast_generate_sr_confirm_cancel_button'
            type='button'
            color='transparent'
            style={{ border: `1px solid ${Colors.grey}` }}
            onClick={props.toggleModal}
          >
            Cancel
          </Button>
          <Button
            id='vessel_forecast_generate_sr_confirm_submit_button'
            type='button'
            color='blue'
            onClick={props.handleSubmit}
          >
            Submit
          </Button>
        </Styled.ActionContainer>
      </div>
    </Styled.StyledDialog>
  )
}

ModalConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default ModalConfirm